import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import moment from 'moment';
import { AgendaService } from '../services/agenda.service';
import { AlertComponent } from '../../../../alert/alert.component';
import { LoadingModalComponent } from '../../../../loading-modal/loading-modal.component';

@Component({
  selector: 'app-criar-agendamento',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AlertComponent,
    LoadingModalComponent,
  ],
  templateUrl: './criar-agendamento.component.html',
  styleUrls: ['./criar-agendamento.component.scss'],
})
export class CriarAgendamentoComponent implements OnInit {
  @Output() closeModal: EventEmitter<void> = new EventEmitter();
  @Input() scheduleId!: string;
  @Input() infoTime: any;
  @Output() concluedAppointmentRegister: EventEmitter<void> =
    new EventEmitter();

  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;

  public formCreateAppointment!: FormGroup;
  public whatsAppointment!: 'schedule' | 'fitting';


  constructor(
    private fb: FormBuilder,
    private readonly agendaService: AgendaService
  ) {
    this.formCreateAppointment = this.fb.group({
      scheduleId: ['', [Validators.required]],
      clientName: ['', [Validators.required]],
      clientPhone: ['', [Validators.required]],
      clientDocument: [''],
      date: [],
      startTime: [''],
      endTime: [''],
      notes: [''],
      status: ['scheduled'],
      origin: [''],
    });
  }

  ngOnInit() {
    this.whatsAppointment = this.infoTime.scheduleId ? 'fitting' : 'schedule';

    this.formCreateAppointment.patchValue({
      scheduleId: this.scheduleId ?? this.infoTime.scheduleId,
      date: this.infoTime.date,
      startTime: this.infoTime.time ?? this.infoTime.startTime,
      endTime: this.infoTime.endTime ?? moment(this.infoTime.time, 'HH:mm')
        .add(moment.duration(this.infoTime.interval).asMinutes(), 'minutes')
        .format('HH:mm'),
    });
  }

  handleMaskPhone() {
    this.formCreateAppointment.patchValue({
      clientPhone: this.applyMaskPhone(
        this.formCreateAppointment.value.clientPhone
      ),
    });
  }

  applyMaskPhone(phone: string): string {
    const numeros = phone.replace(/\D/g, '');
    if (numeros.length === 11) {
      return numeros.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    }

    if (numeros.length === 10) {
      return numeros.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    }

    return phone;
  }

  handleCloseModal() {
    this.closeModal.emit();
  }

  handleSubmit() {
    this.loadingComponent.activeLoading();
    this.formCreateAppointment.patchValue({
      clientPhone: this.formCreateAppointment.value.clientPhone.replace(
        /\D/g,
        ''
      ),
    });

    if(this.whatsAppointment === 'schedule'){
      this.agendaService
      .createAppointment(this.formCreateAppointment.value)
      .subscribe(
        (response: any) => {
          this.alertComponent.showAlert(
            'Agendamento criado com sucesso!',
            'success'
          );
          this.concluedAppointmentRegister.emit();

          this.handleCloseModal();
          this.loadingComponent.inactiveLoading();
        },
        (error: any) => {
          this.loadingComponent.inactiveLoading();
          console.log(error.response);
          this.alertComponent.showAlert(
            `Erro ao criar agendamento: ${error.response.message}`,
            'success'
          );
        }
      );
    }
    
    if(this.whatsAppointment === 'fitting'){
       this.agendaService
      .createAppointmentFitting(this.formCreateAppointment.value)
      .subscribe(
        (response: any) => {
          this.alertComponent.showAlert(
            'Agendamento criado com sucesso!',
            'success'
          );
          this.concluedAppointmentRegister.emit();

          this.handleCloseModal();
          this.loadingComponent.inactiveLoading();
        },
        (error: any) => {
          this.loadingComponent.inactiveLoading();
          console.log(error.response);
          this.alertComponent.showAlert(
            `Erro ao criar agendamento: ${error.response.message}`,
            'success'
          );
        }
      );
    }
    console.log(this.formCreateAppointment.value);
  }
}
